// Shared application constants.

/**
 * Default filter replacement target, in runtime hours, used whenever the
 * backend does not supply a per-device `filter_target_hours`.
 *
 * 720h (30 days of continuous runtime) is the conservative display default the
 * dashboard components already used; the old 2160h fallback in the filter-life
 * calculation was never load-bearing (when the backend real_time block is
 * missing, total runtime is also 0, so the gauge reads 0% used regardless of
 * the denominator). Unifying on 720 means a missing backend target shows the
 * filter as MORE used, prompting replacement sooner rather than under-reporting.
 */
export const DEFAULT_FILTER_TARGET_HOURS = 720;

/**
 * The SmartFilterPro logo, as hosted on the Bubble site. Every page that
 * shows the logo (dashboard header, login, filter recap, QR filter reset)
 * reads it from here, so swapping in a new file or a bundled copy is one
 * change.
 */
export const LOGO_URL =
  'https://51568b615cebbb736b16194a197c101f.cdn.bubble.io/f1722603687332x237952446778578080/Logo.svg';
